import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';
import FullInfoField from 'components/FullInfoField/FullInfoField';

const ContentVersionField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return <FullInfoField label="contentVersionLabel" value={customerForFullInfo?.contentVersion} />;
};

export default ContentVersionField;
